import React, { createContext, ReactNode, FC, useContext, useState } from 'react'
import { Scalars } from 'types/graphqlTypes'
import { TFilters } from 'apps/marketplace/components/PageList'
import { TShipperTrailerFiltersSchema } from './ShipperTrailerFiltersForm/ShipperTrailerFiltersSchema'
import { IShipperTrailersQueryVariables } from './graphql/ShipperTrailers'

export const ITEMS_PER_PAGE = 16

export type TShipperTrailersFilters = TFilters<TShipperTrailerFiltersSchema>

/** Filters that PageList takes in, as well as fields that the ShipperTrailers query may have */
export type TCurrentFilters = Partial<TShipperTrailersFilters> &
  Pick<IShipperTrailersQueryVariables, 'after' | 'before' | 'first' | 'last'>

export const TrailerManagementContext = createContext<{
  currentFilters: TCurrentFilters
  setCurrentFilters: (filters: TCurrentFilters) => void
  itemsPerPage: number
  shipperId: Scalars['ID']
}>({
  currentFilters: { showMissingTrailers: false },
  setCurrentFilters: () => {},
  itemsPerPage: ITEMS_PER_PAGE,
  shipperId: '',
})

export const TrailerManagementContextProvider: FC<{ children: ReactNode; shipperId: string }> = ({
  children,
  shipperId,
}) => {
  const [currentFilters, setCurrentFilters] = useState<TCurrentFilters>({ first: ITEMS_PER_PAGE })
  return (
    <TrailerManagementContext.Provider
      value={{
        currentFilters,
        setCurrentFilters,
        itemsPerPage: ITEMS_PER_PAGE,
        shipperId,
      }}>
      {children}
    </TrailerManagementContext.Provider>
  )
}

export const useTrailerManagementContext = () => useContext(TrailerManagementContext)
